/**
 * @generated SignedSource<<812e5d7a5030bde12b01e89f195b0515>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Widget_component$data = {
  readonly components: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"CompositionChart_component" | "Documents_component" | "FundsManager_component" | "ItemList_component">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly header: string | null | undefined;
  readonly name: string | null | undefined;
  readonly " $fragmentType": "Widget_component";
};
export type Widget_component$key = {
  readonly " $data"?: Widget_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"Widget_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 1000,
      "kind": "LocalArgument",
      "name": "componentsCount"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "salesAdmission"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Widget_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "componentsCount"
        }
      ],
      "concreteType": "ComponentConnection",
      "kind": "LinkedField",
      "name": "components",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FundsManager_component"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CompositionChart_component"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ItemList_component"
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "salesAdmission",
                      "variableName": "salesAdmission"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "Documents_component"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Widget",
  "abstractKey": null
};

(node as any).hash = "a9cef981315dec02b5e014a2fe4fd67c";

export default node;
